import { render, staticRenderFns } from "./lecturerDefault.vue?vue&type=template&id=0abd6b0b&scoped=true"
import script from "./lecturerDefault.vue?vue&type=script&lang=js"
export * from "./lecturerDefault.vue?vue&type=script&lang=js"
import style0 from "./lecturerDefault.vue?vue&type=style&index=0&id=0abd6b0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abd6b0b",
  null
  
)

export default component.exports